import Link from 'next/link'
import moment from 'moment'
import ImageWithFallback from '@/Component/Common/ImageWithFallback'
import CustomTableHead from '@/Component/Common/Tables/CustomTableHead'
import { AdminUserListAPI, DeleteAll, DeleteUser, UserStatusChangeAPI } from '@/Utils/APIRequest/Endpoints'
import { CustomToast } from '@/Utils/CustomToast'
import TableHoc from '@/Utils/HOC/TableHoc'
import usePost from '@/Utils/Hooks/usePost'
import ActiveDeactiveStatus from '@/Component/Common/Tables/ActiveDeactiveStatus'
import { TableDeleteSVG, TableEditSVG, TableEyeSVG } from '@/Component/Common/SVGs/CommonSVG'
import NoDataTable from '@/Component/Common/Tables/NoData/NoDataTable'
import ConfirmationModal from '@/Component/Common/Modal/ConfirmationModal'
import { useState } from 'react'

const BransListingTable = (props) => {
    const { deleteModal, setDeleteModal, selectedItems, setSelectedItems, apiData, translations, enableMultiDelete = false } = props;
    const UserData = apiData?.data?.data;
    const [] = useState<any>([]);


    // API DELETE
    const { isPending: deleteLoader, mutate } = usePost(`${DeleteUser}?id=${deleteModal?.id}`, null, (response) => {
        if (response.status == 200 || response.status == 204) {
            CustomToast("success", 'User deleted successfully')
            apiData?.refetch()
            setDeleteModal(null);
        }
    }, 'delete')

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedItems(UserData.map(user => user.id))
        } else {
            setSelectedItems([])
        }
    }

    const handleSelectItem = (id) => {
        setSelectedItems(prev =>
            prev.includes(id)
                ? prev.filter(item => item !== id)
                : [...prev, id]
        )
    }

    const callbackFunction = () => {
        mutate()
    }

    const tableHeadData = {
        head: [
            ...(enableMultiDelete ? [{
                title: <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={UserData?.length > 0 && selectedItems.length === UserData.length}
                />,
                sorting: false
            }] : []),
            { title: "Sr No.", sorting: false },
            { title: "Full Name", apiKey: "name", sorting: true },
            { title: "Company Name", apiKey: "company_name", sorting: true },
            { title: "Email", apiKey: "email", sorting: true },
            { title: "Business Type", apiKey: "business_type", sorting: true },
            { title: "Working People", apiKey: "working_people", sorting: true },
            { title: "Created At", apiKey: "created_at", sorting: true },
            { title: "Status", apiKey: "is_active", sorting: true },
            { title: "Action", sorting: false },
        ]
    }




    return (
        <>
            <table className="w-full text-sm text-left rtl:text-right">
                <CustomTableHead tableHeadData={tableHeadData} params={apiData?.params} setParams={apiData?.setParams} />
                <tbody>
                    {
                        UserData?.length > 0
                            ?
                            UserData?.map((user, index) => (
                                <tr className="border-b border-lightGray last:border-none font-normal hover:bg-lightGray/20 align-middle" key={index}>
                                    {enableMultiDelete && (
                                        <td className="px-5 py-4">
                                            <input 
                                                type="checkbox"
                                                checked={selectedItems.includes(user.id)}
                                                onChange={() => handleSelectItem(user.id)}
                                            />
                                        </td>
                                    )}
                                    <td className="px-5 py-4">
                                        {((apiData?.params.page - 1) * apiData?.params.per_page) + 1 + index}
                                    </td>
                                    <td className="px-5 py-4 w-56">
                                        <div className="flex items-center capitalize  whitespace-nowrap">
                                            <div className=' px-2 min-w-7 h-7 mr-2 relative rounded-full overflow-hidden'>
                                                <ImageWithFallback src={user?.image} alt='Profile' className='absolute w-full h-full object-cover left-0 right-0 top-0 bottom-0' height={48} width={48} />
                                            </div>
                                            {user?.first_name} {user?.last_name}
                                        </div>
                                    </td>
                                    <td className="px-5 py-4 whitespace-nowrap">
                                        {user?.company_name ? user?.company_name : '-'}
                                    </td>
                                    <td className="px-5 py-4">
                                        {user?.email}
                                    </td>
                                    <td className="px-5 py-4  whitespace-nowrap">
                                        {user?.business_type ? user?.business_type : '-'}
                                    </td>
                                    <td className="px-5 py-4">
                                        {user?.working_people ? user?.working_people : '-'}
                                    </td>
                                    {/* <td className="px-5 py-4">
                                        <span className={`rounded-full py-1 px-4 text-center capitalize text-xs ${user?.is_verify_otp ? 'bg-green-500/30 text-green-500' : 'bg-red-400/30 text-red-400'} `}>
                                            {user?.is_verify_otp ? 'Verified' : 'Not Verified'}
                                        </span>
                                    </td> */}
                                    <td className="px-5 py-4">
                                        {moment.utc(user?.created_at).local().format('DD MMM YYYY')}
                                    </td>
                                    <ActiveDeactiveStatus data={user} apiProps={{ endpoint: `${UserStatusChangeAPI}/${user?.slug}`, path: null }} refetch={apiData?.refetch} translations={translations} />
                                    <td className="px-5 py-4">
                                        <div className="flex items-center">
                                            <Link href={`/admin/brands/${user?.slug}?${apiData?.newQueryParams}`} className='mr-3 p-0.5'>
                                                <TableEyeSVG />
                                            </Link>
                                            <Link href={`/admin/brands/edit/${user?.slug}?${apiData?.newQueryParams}`} className='mr-3 p-0.5'>
                                                <TableEditSVG />
                                            </Link>
                                            <button type='button' className='p-0.5' onClick={() => setDeleteModal(user)} title='Delete'>
                                                <TableDeleteSVG />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                            : <NoDataTable colSpan={9} />
                    }
                </tbody>
            </table>
            {deleteModal && <ConfirmationModal loader={deleteLoader} modal={deleteModal} args={{ message: 'Are you sure you want to delete this user?' }} setModal={setDeleteModal} callbackFunction={callbackFunction} translations={translations} />}
        </>
    )
}

export default TableHoc(BransListingTable)
